import { motion } from "framer-motion";

// Line-by-line masked reveal for headings.
// whileInView is attached to the in-place mask wrapper (observable), which
// propagates the variant to the translated child so it reliably reveals.
export const MaskedLines = ({ lines, className = "", delay = 0, as: Tag = "h2", play = false }) => {
  const trigger = play
    ? { animate: "show" }
    : { whileInView: "show", viewport: { once: true, margin: "-12%" } };
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <motion.span key={i} className="reveal-mask" initial="hide" {...trigger}>
          <motion.span
            className="block"
            variants={{ hide: { y: "110%" }, show: { y: "0%" } }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: delay + i * 0.09 }}
          >
            {line}
          </motion.span>
        </motion.span>
      ))}
    </Tag>
  );
};

export const FadeUp = ({ children, className = "", delay = 0, y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay }}
  >
    {children}
  </motion.div>
);
